import React from "react";
import { Box, Typography, Stack, IconButton } from "@mui/material";
import {
  NoteOutlined,
  CalendarMonthOutlined,
  LocationOnOutlined,
  GroupOutlined,
  ConfirmationNumberOutlined,
  PersonOutlineOutlined,
  ShareOutlined,
  MoreVertOutlined,
} from "@mui/icons-material";
import { colors, theme } from "../../theme/theme";
import { CustomBtn } from "../Common/CustomBtn";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import { useSelector } from "react-redux";

const EventsCard = ({ item }) => {
  const { userData } = useSelector((state) => state.user);

  const navigate = useNavigate();
  return (
    <Box
      sx={{
        width: "100%",
        height: "550px",
        borderRadius: 4,
        overflow: "hidden",
        position: "relative",
        boxShadow: "0 0 12px rgba(0,0,0,0.3)",
        border: theme.lightBorder,
        mb: 2,
        cursor: "pointer",
        "&:hover": {
          boxShadow: "0 0 20px rgba(0,0,0,0.5)",
          border: `1px solid ${colors.secondary}`,
        },
        "&:active": {
          boxShadow: "0 0 20px rgba(0,0,0,0.5)",
          border: `1px solid ${colors.secondary}`,
        },
        // border: "1px solid transparent",
        // borderImageSource:
        //   "linear-gradient(90deg, rgba(247, 132, 25, 0.5) 0%, rgba(201, 50, 33, 0.5) 100%)",
        // borderImageSlice: 1,
        // backgroundOrigin: "border-box",
        // backgroundClip: "padding-box, border-box, border-box, border-box",
      }}
      onClick={() =>
        navigate(`/events/event-details`, {
          state: { eventId: item?.id },
        })
      }
    >
      <Box
        component="img"
        src={item?.image_url}
        alt="event"
        sx={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
          position: "absolute",
          top: 0,
          left: 0,
          zIndex: 1,
        }}
      />

      <Box
        sx={{
          position: "absolute",
          bottom: 0,
          height: "60%",
          background:
            "linear-gradient(180deg, rgba(17, 24, 35, 0) 0%, rgba(17, 24, 35, 0.654118) 32.1%, #111823 55.09%)",
          zIndex: 2,
          px: 2,
          py: 2,
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-end",
          width: "95%",
        }}
      >
        <Stack direction="row" spacing={1} flexWrap="wrap">
          {item?.interest_tags &&
            item?.interest_tags?.map((tag) => (
              <Typography
                key={tag}
                sx={{
                  fontSize: "12px",
                  fontFamily: "Mulish-Light",
                  color: colors.secondary,
                }}
              >
                {"#" + tag}
              </Typography>
            ))}
        </Stack>

        <Stack
          direction="row"
          alignItems="center"
          mb={1.5}
          justifyContent={"space-between"}
        >
          <Typography
            sx={{
              fontSize: "32px",
              fontFamily: "Mulish-ExtraBold",
              color: "#fff",
            }}
          >
            {item?.title}
          </Typography>
          <Stack direction="row" spacing={1}>
            <IconButton>
              <ShareOutlined sx={{ fontSize: 20, color: "#fff" }} />
            </IconButton>
            <IconButton>
              <MoreVertOutlined sx={{ fontSize: 20, color: "#fff" }} />
            </IconButton>
          </Stack>
        </Stack>
        <Stack direction={"row"} spacing={1} mb={1}>
          <NoteOutlined sx={{ fontSize: 16, color: colors.secondary }} />
          <Typography
            sx={{
              fontSize: "13px",
              color: "#fff",
              fontFamily: "Mulish-Light",
            }}
          >
            {item?.description}
          </Typography>
        </Stack>

        <Stack direction="row" flexWrap="wrap" spacing={2} mb={1}>
          <Stack direction="row" spacing={1} alignItems="center">
            <CalendarMonthOutlined
              sx={{ fontSize: 16, color: colors.secondary }}
            />
            <Typography
              sx={{
                fontSize: "12px",
                color: "#fff",
                fontFamily: "Mulish-Light",
              }}
            >
              {dayjs(item?.event_date).format("DD MMM YYYY")}
            </Typography>
          </Stack>
          <Stack direction="row" spacing={1} alignItems="center">
            <LocationOnOutlined
              sx={{ fontSize: 16, color: colors.secondary }}
            />
            <Typography
              sx={{
                fontSize: "12px",
                color: "#fff",
                fontFamily: "Mulish-Light",
              }}
            >
              {item?.event_type === "virtual"
                ? item?.event_type
                : item?.location}
            </Typography>
          </Stack>
          <Stack direction="row" spacing={1} alignItems="center">
            <GroupOutlined sx={{ fontSize: 16, color: colors.secondary }} />
            <Typography
              sx={{
                fontSize: "12px",
                color: "#fff",
                fontFamily: "Mulish-Light",
              }}
            >
              0 people
            </Typography>
          </Stack>
          <Stack direction="row" spacing={0.5} alignItems="center">
            <ConfirmationNumberOutlined
              sx={{ fontSize: 16, color: colors.secondary }}
            />
            <Typography
              sx={{
                fontSize: "12px",
                color: "#fff",
                fontFamily: "Mulish-Light",
              }}
            >
              {item?.ticket_price === "0"
                ? "Free Ticket"
                : `$${item?.ticket_price}`}
            </Typography>
          </Stack>
        </Stack>

        <Stack direction="row" spacing={1} alignItems="center" mb={2}>
          <PersonOutlineOutlined
            sx={{ fontSize: 16, color: colors.secondary }}
          />
          <Typography
            sx={{ fontSize: "12px", color: "#fff", fontFamily: "Mulish-Light" }}
          >
            Organized by{" "}
            <Typography
              component="span"
              sx={{
                color: colors.secondary,
                fontSize: "12px",
                fontFamily: "Mulish-Light",
                cursor: "pointer",
                "&:hover": {
                  textDecoration: "underline",
                },
              }}
            >
              {`@${item?.User?.firstName} ${item?.User?.lastName}`}
            </Typography>
          </Typography>
        </Stack>

        <CustomBtn
          text={
            item?.event_participants?.find(
              (participant) => participant?.user_id === userData?.id
            )
              ? "Going"
              : "Join"
          }
          width="100%"
          height="40px"
          fontSize="16px"
          icon
          onClick={() =>
            navigate(`/events/event-details`, {
              state: { eventId: item?.id },
            })
          }
        />
      </Box>
    </Box>
  );
};

export default EventsCard;
